import { Box, Grid, Typography } from "@mui/material";
import { useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import QRFindTagId from "./qrFindTagId";
import QRTagDetailsWithTagId from "./qrTagDetailsWithTagId";


export default function QRTagDetails() {
    const [tagId, setTagId] = useState()
    const location = useLocation()

    const navigateToTagDetails = useNavigateWithParams('/tag/details') // navigate to this url but with a tag_id parameter

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const paramTagId = searchParams.get('tag_id')
        setTagId(paramTagId || undefined)
        // console.log('QRTagDetails useEffect got paramTagId', paramTagId)
    }, [location])

    const handleFindTagId = (newTagId) => {
        // console.log('QRTagDetails handleFindTagId got newTagId', newTagId)
        // setTagId(newTagId)
        navigateToTagDetails({tag_id: newTagId})
    }

    return (
        <Box>
            <h2 className="np-title" style={{marginBottom: 0}}>Safety Isolation Tag Details</h2>
            <Typography variant="body2" paragraph>Tag {tagId}</Typography>

            <Grid container sx={{my:2}}>
                <Grid item xs={12} md={3}></Grid>
                <Grid item xs={12} md={6}>
                {
                    !tagId
                ?
                    <QRFindTagId tagId={tagId} onFindTagId={handleFindTagId} />
                :
                    <QRTagDetailsWithTagId tagId={tagId} />
                }
                </Grid>
                <Grid item xs={12} md={3}></Grid>
            </Grid>
        </Box>

    )
}






